<mat-card [@WindowOpenClose]="windowVisible.getValue() ? 'visible' : 'invisible'" class="plot-aro"
  (click)="windowClick()">
  <dialog-header [label]="title" [dialogRef]='dialogRef' [object]='this' [objectType]='"Sensor"'
    (mousedown)="windowClick()"></dialog-header>

  <!-- Icon area -->
  <mat-card class="box-bottom-padding-and-border" style="height: 115px;">
    <mat-grid-list cols="15" rowHeight="115">
      <mat-grid-tile colspan="5">
        <div fxLayout="column" fxLayoutAlign="center center" (dblclick)="changeCameraStatus()">
          <div>
            <img src="./assets/Images/plane-circle.svg" class="aro-image" />
            <div class="sensor-image" [style.background-color]="identityColor" [style.-webkit-mask-image]="sensorSym">
            </div>
          </div>
        </div>
      </mat-grid-tile>
      <mat-grid-tile colspan="10" style="right: auto">
        <div fxFlex="100%" fxLayout="column">
          <div *ngIf="sensor.isRadar" fxFlex="100%" fxLayout="row" fxLayoutAlign="center center">
            <div fxFlex="100%" fxLayout="column" fxLayoutAlign="center center">
              <div>{{sensor.sic}}</div>
              <div class="aro-label">Sic</div>
            </div>
            <div fxFlex="100%" fxLayout="column" fxLayoutAlign="center center">
              <div>{{sensor.sac}}</div>
              <div class="aro-label" style="word-break: unset;">Sac</div>
            </div>
          </div>
          <div fxFlex="100%" fxLayout="row" fxLayoutAlign="center center">
            <div fxFlex="100%" fxLayout="column" fxLayoutAlign="center center">
              <div>{{SensorType}}</div>
              <div class="aro-label">{{'ARO.SENSOR2D3D' | translate}}</div>
            </div>
            <div *ngIf="sensor.isVideo || sensor.isAcoustic" fxFlex="100%" fxLayout="column" fxLayoutAlign="center center">
              <div *ngIf="!sensor.isNewCamera">{{streamName}}</div>
              <input *ngIf="sensor.isNewCamera" matInput [(ngModel)]="sensor.streamName" type="text">
              <div class="aro-label">Stream-Name</div>
            </div>
          </div>
          <div style="margin-top: 10px; align-self: center;" *ngIf="!sensor.isRadar && !sensor.isNewCamera">
            <span class="buttonContainer"
              style="padding-right: 5px; border-top-right-radius: 30px; border-bottom-right-radius: 30px;">
              <button mat-icon-button (click)="OpenSoundWindow()" class="backroundButt" [disabled]="disablePlayBtn"
                [matTooltip]="sensor.isAcoustic ? 'Open Sound Window' : 'Open Video Window'">
                <mat-icon>play_arrow</mat-icon>
              </button>
            </span>
          </div>
        </div>
      </mat-grid-tile>
    </mat-grid-list>
    <p></p>
  </mat-card>

  <!-- coord comp -->
  <mat-card class="box-bottom-padding-and-border">
    <mat-icon class="location-icon">place</mat-icon>
    <app-coords *ngIf="sensor.isNewCamera || sensor.isEditCamera" #coords [Geo]="sensor.geometry"  [isEditOnly]="true"></app-coords>
    <app-coords *ngIf="!sensor.isNewCamera && !sensor.isEditCamera" #coords [Geo]="sensor.geometry" [isReadOnly]=true></app-coords>
  </mat-card>


  <!-- Altitude/Time/Radar data -->
  <mat-card *ngIf="!sensor.isNewCamera && !sensor.isEditCamera" class="box-bottom-padding-and-border">
    <div fxLayout="row" fxLayoutGap="20px" fxLayoutAlign="space-evenly">
      <div fxFlex="33.3%" fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="5px" [matTooltip]="'Altitude'"
        [matTooltipPosition]="'above'">
        <app-heightimage></app-heightimage>
        <div class="plot-basic-data-value">{{altitude}} {{altitudeUnits}}</div>
      </div>
      <div fxFlex="33.3%" fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="5px"
        [matTooltip]="'Last Update Time'" [matTooltipPosition]="'above'">
        <app-clockimage></app-clockimage>
        <div class="plot-basic-data-value">{{time}}</div>
      </div>
      <div fxFlex="33.3%" fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="5px" [matTooltip]="'Sensor ID'"
        [matTooltipPosition]="'above'">
        <app-sensorimage></app-sensorimage>
        <div class="plot-basic-data-value">{{sensorId}}{{sensor.isRadar ? '(' + sensorSymbol + ')' : ''}}</div>
      </div>
    </div>
  </mat-card>

   <mat-card *ngIf="sensor.isNewCamera || sensor.isEditCamera" class="box-bottom-padding-and-border" style="height: 200px;">
    <mat-form-field class="sensor-form-field">
        <!--textarea matInput [value]="sensor.videoLink" rows="2" class="sensor-input-text-area"></textarea-->
        <input matInput [(ngModel)]="sensor.videoLink" type="text" class="sensor-input-text-area">
    </mat-form-field>
    <div class="aro-label">WebURL</div>
    <mat-form-field class="sensor-form-field">
      <input matInput [(ngModel)]="natiRtsp" type="text" class="sensor-input-text-area">
    </mat-form-field>
    <div class="aro-label">Nati RTSP</div>
  </mat-card>

  <!-- if a sensor is acoustic we can limit the angles in which lines will be drawn -->
  <mat-card *ngIf="sensor.isAcoustic" fxLayout="row" fxLayoutAlign="space-around center"
    class="box-bottom-padding-and-border">
    <app-basic-field-number-w #MinCoverageAng fxFlex [RealValue]="sensor != undefined ?sensor.azimuthBias : undefined"
      [Title]="'Min Degree'" [MinVal]=-360 [MaxVal]=360 [MaxNumsAfterDot]=2 [FrontDecor]="'°'"
      (TriggerTextChanged)="CoverageValsChanged()">
    </app-basic-field-number-w>
    <app-basic-field-number-w #MaxCoverageAng fxFlex [RealValue]="sensor != undefined ?sensor.azimuthBias : undefined"
      [Title]="'Max Degree'" [MinVal]=-360 [MaxVal]=360 [MaxNumsAfterDot]=2 [FrontDecor]="'°'"
      (TriggerTextChanged)="CoverageValsChanged()">
    </app-basic-field-number-w>
  </mat-card>

  <div *ngIf="sensor.isNewCamera || sensor.isEditCamera" fxLayoutAlign="center center">
    <button class="button-border-margin" mat-stroked-button (click)="saveCameraClick()">
      {{'ACTIONS.SAVE' | translate}} </button>
  </div>


</mat-card>